import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-773af192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "news-heading" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "gradient__text" }, "The Latest News")
], -1))
const _hoisted_3 = { class: "news-container" }
const _hoisted_4 = { class: "news-container_groupB" }

import NewsCard from "@/components/NewsCard.vue";
import news from "@/shared/news";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsSection',
  setup(__props) {

const router = useRouter();

const goToNewsDetailPage = (id: number) => {
  router.push({ name: "NewsComponent", params: { id: id } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(news).slice(0, 3), (news1) => {
          return (_openBlock(), _createBlock(NewsCard, {
            key: news1.index,
            class: "news-card__second",
            imgUrl: news1.photo,
            date: news1.date,
            title: news1.title,
            subtitle: news1.subtitle ? news1.subtitle : '',
            onClick: ($event: any) => (goToNewsDetailPage(news1.index))
          }, null, 8, ["imgUrl", "date", "title", "subtitle", "onClick"]))
        }), 128))
      ])
    ])
  ]))
}
}

})